import { CommonModule, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import { Component, computed, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SwiperModule } from 'swiper/angular';
import { SwiperOptions } from 'swiper';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;

@Component({
  selector: 'iho-footer-features',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, SwiperModule],
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
})
export class FooterFeaturesComponent implements OnInit {
  cdnUrl = cdnUrl
  private searchBoxService = inject(SearchBoxService);
  accommodation = computed(() => this.searchBoxService.accommodation());
  
  configSwiper: SwiperOptions = {};
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  ngOnInit(): void {
    this.configSwiper = {
      slidesPerView: 1.3,
      spaceBetween: 12,
      grabCursor: true,
      autoplay: {
        delay: 4000,
      },
    };
  }
}
